import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { immigrateCategoryAPI } from 'features/immigrate-category/api'
import {
  IMMIGRATE_CATEGORY_EDIT_SUBMIT_REQUEST,
  IMMIGRATE_CATEGORY_EDIT_SUBMIT_SUCCESS,
  IMMIGRATE_CATEGORY_EDIT_SUBMIT_FAILED,
} from './actionTypes'

export const immigrateCategoryEditSubmitPA = createPromiseAction(
  IMMIGRATE_CATEGORY_EDIT_SUBMIT_REQUEST,
  IMMIGRATE_CATEGORY_EDIT_SUBMIT_SUCCESS,
  IMMIGRATE_CATEGORY_EDIT_SUBMIT_FAILED
)()

function* submit(action) {
  try {
    const { id, params } = action.payload
    const response = yield call(immigrateCategoryAPI.updateCategory, id, params)
    const { data } = response

    yield put(immigrateCategoryEditSubmitPA.success({}))

    resolvePromiseAction(action, { ...data.data })
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* submitSaga() {
  yield takeEvery(immigrateCategoryEditSubmitPA.request, submit)
}
